import styled from "styled-components";

import { SectionSubheading } from "@olist/design-system";

export const FileUploadLabel = styled.div`
  display: flex;

  & > p:first-child {
    margin-right: 8px;
  }
`;

export const InputWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.background?.secondary || "white"};
  border: 1px solid ${({ theme }) => theme.border?.color || "#ddd"};
  border-radius: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: inline-flex;
  font-size: 16px;
  font-weight: 500;
  gap: 8px;
  padding: 4px 14px 4px 4px;
  transition: background 0.2s;

  width: fit-content;

  &:hover {
    background: ${({ theme }) => theme.background?.tertiary || "#f9f9f9"};
  }

  svg {
    background-color: ${({ theme }) => theme.text?.accent || "#005ff9"};
    border-radius: 50%;
    color: white;
    height: 24px;
    padding: 6px;
    width: 24px;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Note = styled.p`
  color: ${({ theme }) => theme.text?.secondary || "#666"};
  font-size: 13px;
  margin-top: 8px;
`;

export const UploadTitle = styled(SectionSubheading)`
  color: ${({ theme }) => theme.text?.primary || "inherit"};
  font-size: 16px;
  margin: 32px 0 16px;
`;
